<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" width="16" height="16">
    <polyline points="18 15 12 9 6 15" />
  </svg>
</template>

<script>
export default {
  name: 'ChevronUpIcon'
}
</script>
